import { useState } from 'react';
import './Services.css';
import './ServiceDetails.css';
import { servicesData } from '../data/servicesData';

const IconCheck = () => (
  <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
    <path d="M22 11.08V12a10 10 0 1 1-5.93-9.14" />
    <polyline points="22 4 12 14.01 9 11.01" />
  </svg>
);

export const svcIcons = {
  globe: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><line x1="2" y1="12" x2="22" y2="12" />
      <path d="M12 2a15.3 15.3 0 0 1 4 10 15.3 15.3 0 0 1-4 10 15.3 15.3 0 0 1-4-10 15.3 15.3 0 0 1 4-10z" />
    </svg>
  ),
  trending: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polyline points="23 6 13.5 15.5 8.5 10.5 1 18" /><polyline points="17 6 23 6 23 12" />
    </svg>
  ),
  palette: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="13.5" cy="6.5" r=".5" /><circle cx="17.5" cy="10.5" r=".5" /><circle cx="8.5" cy="7.5" r=".5" /><circle cx="6.5" cy="12.5" r=".5" />
      <path d="M12 2C6.5 2 2 6.5 2 12s4.5 10 10 10c.9 0 1.5-.7 1.5-1.5 0-.4-.2-.8-.4-1.1-.2-.3-.4-.7-.4-1.1 0-.8.7-1.5 1.5-1.5H16c3.3 0 6-2.7 6-6 0-4.9-4.5-9-10-9z" />
    </svg>
  ),
  cpu: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <rect x="4" y="4" width="16" height="16" rx="2" /><rect x="9" y="9" width="6" height="6" />
      <line x1="9" y1="1" x2="9" y2="4" /><line x1="15" y1="1" x2="15" y2="4" />
      <line x1="9" y1="20" x2="9" y2="23" /><line x1="15" y1="20" x2="15" y2="23" />
      <line x1="20" y1="9" x2="23" y2="9" /><line x1="20" y1="14" x2="23" y2="14" />
      <line x1="1" y1="9" x2="4" y2="9" /><line x1="1" y1="14" x2="4" y2="14" />
    </svg>
  ),
  layers: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <polygon points="12 2 2 7 12 12 22 7 12 2" /><polyline points="2 17 12 22 22 17" /><polyline points="2 12 12 17 22 12" />
    </svg>
  ),
  cart: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="9" cy="21" r="1" /><circle cx="20" cy="21" r="1" />
      <path d="M1 1h4l2.68 13.39a2 2 0 0 0 2 1.61h9.72a2 2 0 0 0 2-1.61L23 6H6" />
    </svg>
  ),
  search: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="11" cy="11" r="8" /><line x1="21" y1="21" x2="16.65" y2="16.65" />
    </svg>
  ),
  target: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="12" cy="12" r="10" /><circle cx="12" cy="12" r="6" /><circle cx="12" cy="12" r="2" />
    </svg>
  ),
  share: (
    <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round">
      <circle cx="18" cy="5" r="3" /><circle cx="6" cy="12" r="3" /><circle cx="18" cy="19" r="3" />
      <line x1="8.59" y1="13.51" x2="15.42" y2="17.49" /><line x1="15.41" y1="6.51" x2="8.59" y2="10.49" />
    </svg>
  ),
};

export const services = servicesData;

// Services page — tabbed explorer. Click a service tab to preview it,
// then jump to its full dedicated page for the complete details.
export default function Services() {
  const [activeSlug, setActiveSlug] = useState(servicesData[0].slug);
  const active = servicesData.find(s => s.slug === activeSlug);

  return (
    <section id="services" className="services-section">
      <div className="services-header reveal">
        <span className="section-label">What We Do</span>
        <h2 className="section-title">Services That <em>Drive Growth</em></h2>
        <p className="section-sub">From concept to execution, we provide end-to-end digital solutions that help your business stand out and scale.</p>
      </div>

      {/* Tab bar */}
      <div className="svc-tabs reveal" role="tablist">
        {servicesData.map(s => (
          <button
            key={s.slug}
            role="tab"
            aria-selected={s.slug === activeSlug}
            className={`svc-tab ${s.slug === activeSlug ? 'active' : ''}`}
            onClick={() => setActiveSlug(s.slug)}
          >
            <span className="svc-tab-icon">{svcIcons[s.icon]}</span>
            {s.title}
          </button>
        ))}
      </div>

      {/* Active service panel */}
      <div className="sd-section svc-panel-wrap">
        <div className="sd-row" key={active.slug}>
          <div className="sd-content reveal-left">
            <span className="svc-panel-icon">{svcIcons[active.icon]}</span>
            <span className="svc-panel-tagline">{active.tagline}</span>
            <h3 className="sd-title">{active.title}</h3>
            <p className="sd-intro">{active.intro}</p>

            {active.stats && (
              <div className="svc-stats-row">
                {active.stats.map(st => (
                  <div key={st.label} className="svc-stat-pill">
                    <span className="svc-stat-value">{st.value}</span>
                    <span className="svc-stat-label">{st.label}</span>
                  </div>
                ))}
              </div>
            )}

            <h4 className="sd-subhead">Key Features</h4>
            <ul className="sd-list">
              {active.features.slice(0, 4).map(f => (
                <li key={f}><span className="sd-check"><IconCheck /></span>{f}</li>
              ))}
            </ul>

            <a href={`#/services/${active.slug}`} className="btn-white svc-panel-cta">
              View Full Details →
            </a>
          </div>
          <div className="sd-img reveal-right">
            <img src={active.img} alt={active.title} loading="lazy" />
          </div>
        </div>
      </div>
    </section>
  );
}
